<template>
    <BreadCrumb PageTitle="Modifier une proposition de réponse" />
    <EditPropositionReponse />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import EditPropositionReponse from "@/components/PropositionReponse/EditPropositionReponse.vue";
  
    export default defineComponent({
      name: "EditPropositionPage",
      components: {
        BreadCrumb,
        EditPropositionReponse,
      },
    });
  </script>